import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryJobForUser } from 'src/app/shared/services/user-jobs.service';

@Pipe({
  name: 'deliveryItemsList',
  standalone: true
})
export class DeliveryItemsListPipe implements PipeTransform {
  transform(value: DeliveryJobForUser['items']): string {
    return value.map((item) => item.delivery_note_description).join(', ');
  }
}
